import type { ColumnInfoCollectionInterface, ColumnInfoInterface, ColumnsProviderInterface, ExternalColumnMapInfoInterface, UserLayoutMetaDataInterface } from '@nts/std/interfaces';
import { UserLayoutMetaData } from '../layout-meta-data/user-layout-meta-data';

export class ColumnsProvider implements ColumnsProviderInterface {

    readonly customGridColumns: Map<string, ColumnInfoCollectionInterface>;
    readonly gridColumns: Map<string, ColumnInfoCollectionInterface>;
    readonly userLayoutMetaData: UserLayoutMetaDataInterface;

    constructor(
        gridColumns: Map<string, ColumnInfoCollectionInterface>,
        customGridColumns: Map<string, ColumnInfoCollectionInterface> = null,
        userLayoutMetaData: UserLayoutMetaDataInterface = null
    ) {
        this.gridColumns = gridColumns;
        this.customGridColumns = customGridColumns ?? new Map<string, ColumnInfoCollectionInterface>();
        this.userLayoutMetaData = userLayoutMetaData ?? new UserLayoutMetaData();
    }

    getExternalColumns(entityTypeName: string, externalColumnsMapInfo: ExternalColumnMapInfoInterface[]): ColumnInfoInterface[] {
        return [];
    }
}
